import React from 'react';
import './index.css';

import IconTrashCan from '../icons/IconTrashCan'

const BinNameDeletable = ({row, onClick, disabled,part, acceptedParts}) => {

   const text = [part ? row.primaryPartnum:row.binName ]

    const idMatches = acceptedParts ? acceptedParts.filter(part => row.id.includes(part.partnum)) : [];

  return (
    <span className="bin-name-deletable">
      <span className="bin-name-deletable__bin-name">{text}</span>
      {!disabled && !idMatches.length > 0  &&
        <IconTrashCan
          onClick={() => onClick(row)}
          className="bin-name-deletable__icon"
        />
      }
    </span>
  );
}

export default BinNameDeletable;
